namespace SP {
    export enum ReturnMethod {
        ReceiveOnly = 1,
        ReceiveAndRefund = 2,
        ReceiveAndRefundAndConfirm = 3,
        ReceiveAndRefundAndConfirmExclGiftcard = 4,
    }
}